export default __webpack_public_path__ + "static/media/playstation.4bbb4079.svg";